import React from 'react';
import { Box } from '@mui/material';

import PasswordInput from '../../../common/form/PasswordInput';
import Button from '../../../common/buttons/Button';
import { InnerNavigationButtons, PrimaryActionButton } from './styles';

interface PasswordEntryStepProps {
	password: string;
	handlePasswordChange: (newPassword: string) => void;
	handlePasswordSubmit: () => void;
	passwordError: string;
	isVerifying: boolean;
}

export default function PasswordEntryStep({
	password,
	handlePasswordChange,
	handlePasswordSubmit,
	passwordError,
	isVerifying,
}: PasswordEntryStepProps) {
	return (
		<Box
			sx={{
				py: 4,
				px: 2,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}
		>
			<PasswordInput
				value={password || ''}
				onChange={handlePasswordChange}
				error={passwordError}
				disabled={isVerifying}
				showInstructions={true}
			/>

			<InnerNavigationButtons>
				<PrimaryActionButton
					variant="contained"
					onClick={handlePasswordSubmit}
					disabled={!password || password.length !== 6 || isVerifying}
				>
					{isVerifying ? 'Verifying...' : 'Continue'}
				</PrimaryActionButton>
			</InnerNavigationButtons>
		</Box>
	);
}
